"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultFilterSelectInput = exports.IconContainer = exports.DefaultFilterSelectContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const Icon_1 = require("../Icon");
const Input_1 = require("../Input");
exports.DefaultFilterSelectContainer = styled_components_1.default.div `
  width: 100%;

  input {
    padding-right: 30px;
  }
`;
exports.IconContainer = styled_components_1.default.div `
  position: absolute;
  transform: translate(-50%,-50%);
  top: 50%;
  right: 0;
  cursor: pointer;
`;
const DefaultFilterSelectInput = ({ filter, open, toggle, }) => {
    const theme = (0, styled_components_1.useTheme)();
    const onClick = react_1.default.useCallback(() => {
        toggle();
        filter.clearSearch();
    }, [toggle, filter]);
    return ((0, jsx_runtime_1.jsxs)(exports.DefaultFilterSelectContainer, { children: [(0, jsx_runtime_1.jsx)(Input_1.Input.Text, { onClick: onClick, onChange: (next) => {
                    open();
                    filter.onInputChange(next);
                }, value: filter.input }), (0, jsx_runtime_1.jsx)(exports.IconContainer, Object.assign({ onClick: onClick }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, Object.assign({ color: theme.Color.Text.Secondary }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon.CaretDown, {}) })) }))] }));
};
exports.DefaultFilterSelectInput = DefaultFilterSelectInput;
